export const APP_CONFIG = {
    APP_NAME: process.env.REACT_APP_APP_NAME || 'Regentra',
    COMPANY_NAME: process.env.REACT_APP_COMPANY_NAME || 'Ferrum Legis',
    ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
};

export const API_ENDPOINTS = {
    AUTH: {
        LOGIN: '/auth/login',
        LOGOUT: '/auth/logout',
        REFRESH: '/auth/refresh',
        ME: '/auth/me',
        FORGOT_PASSWORD: '/auth/forgot-password',
        RESET_PASSWORD: '/auth/reset-password',
        INIT_PASSWORD: '/auth/init-password',
    },
    TENANTS: {
        LIST: '/tenants',
        SELECT: '/tenants/select',
    },
    DASHBOARD: {
        STATS: '/dashboard/stats',
        RECENT_ACTIVITY: '/dashboard/recent-activity',
    },
    TASKS: {
        LIST: '/tasks',
        CREATE: '/tasks',
        UPDATE: '/tasks/:id',
        DELETE: '/tasks/:id',
    },
    REGULATORY: {
        UPDATES: '/regulatory/updates',
        DOCUMENTS: '/regulatory/documents',
    },
    REPORTS: {
        LIST: '/reports',
        GENERATE: '/reports/generate',
    },
    SCHUTZBEDARFSANALYSE: {
        PROZESSE: '/api/schutzbedarfsanalyse/prozesse',
        PROZESS_BY_ID: '/api/schutzbedarfsanalyse/prozesse/:id',
        ANALYSEN: '/api/schutzbedarfsanalyse/analysen',
        ANALYSE_BY_ID: '/api/schutzbedarfsanalyse/analysen/:id',
        RISIKEN: '/api/schutzbedarfsanalyse/risiken',
        RISIKO_BY_ID: '/api/schutzbedarfsanalyse/risiken/:id',
        MASSNAHMEN: '/api/schutzbedarfsanalyse/massnahmen',
        MASSNAHME_BY_ID: '/api/schutzbedarfsanalyse/massnahmen/:id',
        ANWENDUNGEN: '/api/schutzbedarfsanalyse/anwendungen',
        ANWENDUNG_BY_ID: '/api/schutzbedarfsanalyse/anwendungen/:id',
        ANWENDUNGSANALYSEN: '/api/schutzbedarfsanalyse/anwendungsanalysen',
        ANWENDUNGSANALYSE_BY_ID: '/api/schutzbedarfsanalyse/anwendungsanalysen/:id',
        GAP_ANALYSEN: '/api/schutzbedarfsanalyse/gap-analysen',
        GAP_ANALYSE_BY_ID: '/api/schutzbedarfsanalyse/gap-analysen/:id',
        GAP_STATS: '/api/schutzbedarfsanalyse/gap-analysen/stats',
    },
};

export const ROUTES = {
    LOGIN: '/login',
    INIT_PASSWORD: '/init-password',
    FORGOT_PASSWORD: '/forgot-password',
    TENANT_SELECTION: '/tenant-selection',
    DASHBOARD: '/dashboard',
    TASKS: '/',
    REPORTS: '/',
    SETTINGS: '/',
    REGULATORIK: '/regulatorik',
    REGULATORIK_NEUIGKEITEN: '/regulatorik/neuigkeiten',
    REGULATORIK_ARCHIV: '/regulatorik/archiv',
    REGULATORIK_GESETZE: '/regulatorik/gesetze',
    SCHUTZBEDARFSANALYSE: '/schutzbedarfsanalyse',
    SCHUTZBEDARFSANALYSE_PROZESSE: '/schutzbedarfsanalyse/prozesse',
    SCHUTZBEDARFSANALYSE_ANWENDUNGEN: '/schutzbedarfsanalyse/anwendungen',
    SCHUTZBEDARFSANALYSE_ANALYSEN: '/schutzbedarfsanalyse/analysen',
    SCHUTZBEDARFSANALYSE_GAP_ANALYSEN: '/schutzbedarfsanalyse/gap-analysen',
    SCHUTZBEDARFSANALYSE_RISIKEN: '/schutzbedarfsanalyse/risiken',
    SCHUTZBEDARFSANALYSE_MASSNAHMEN: '/schutzbedarfsanalyse/massnahmen',
};

export const MENU_ITEMS = [
    { id: 'tasks', label: 'Aufgaben', icon: 'tasks', route: ROUTES.TASKS, implemented: false },
    { id: 'calendar', label: 'Meldekalender', icon: 'calendar', route: '/', implemented: false },
    { id: 'approvals', label: 'Freigaben', icon: 'check', route: '/', implemented: false },
    { id: 'money-laundering', label: 'Geldwäsche', route: '/', implemented: false },
    { id: 'outsourcing', label: 'Auslagerung', route: '/', implemented: false },
    { id: 'regulatory', label: 'Regulatorik', route: ROUTES.REGULATORIK, implemented: true },
    { id: 'guidelines', label: 'Richtlinien', route: '/', implemented: false },
    { id: 'audit', label: 'Audit Management', route: '/', implemented: false },
    { id: 'documentation', label: 'Dokumentation', route: '/', implemented: false },
    { id: 'training', label: 'Schulung', route: '/', implemented: false },
];

// Schutzbedarfsanalyse Module
export const SCHUTZBEDARFSANALYSE_MODULES = {
    INFORMATIONSSICHERHEIT: 'informationssicherheit',
    RISIKOMANAGEMENT: 'risikomanagement',
};

// Welche Tabs für welches Modul sichtbar sind
export const MODULE_TABS = {
    [SCHUTZBEDARFSANALYSE_MODULES.INFORMATIONSSICHERHEIT]: ['prozesse', 'anwendungen', 'analysen', 'gap-analysen'],
    [SCHUTZBEDARFSANALYSE_MODULES.RISIKOMANAGEMENT]: ['risiken', 'massnahmen'],
};

// Module Labels für Header
export const MODULE_LABELS = {
    [SCHUTZBEDARFSANALYSE_MODULES.INFORMATIONSSICHERHEIT]: 'Informationssicherheit',
    [SCHUTZBEDARFSANALYSE_MODULES.RISIKOMANAGEMENT]: 'Risikomanagement',
};

// GAP Categories
export const GAP_KATEGORIEN = {
    funktional: 'Funktionale GAP',
    kontroll: 'Kontroll-GAP',
    dokumentation: 'Dokumentations-GAP',
    integration: 'Integrations-GAP',
    governance: 'Governance-GAP'
};

// GAP Kritikalität
export const GAP_KRITIKALITAET = {
    kritisch: { label: 'Kritisch', color: '#dc2626' },
    hoch: { label: 'Hoch', color: '#f59e0b' },
    mittel: { label: 'Mittel', color: '#fbbf24' },
    niedrig: { label: 'Niedrig', color: '#10b981' }
};

// Maßnahmen Status
export const MASSNAHMEN_STATUS = {
    offen: { label: 'Offen', color: '#9ca3af' },
    in_planung: { label: 'In Planung', color: '#6366f1' },
    in_umsetzung: { label: 'In Umsetzung', color: '#3b82f6' },
    abgeschlossen: { label: 'Abgeschlossen', color: '#10b981' },
    zurueckgestellt: { label: 'Zurückgestellt', color: '#ef4444' }
};

// Maßnahmen Typ
export const MASSNAHMEN_TYP = {
    technisch: 'Technisch',
    organisatorisch: 'Organisatorisch',
    prozessual: 'Prozessual'
};